<template>
  <div class="wrapper">
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border
      style="margin:10px 0;min-height:55vh">
      <template slot-scope="{ row }" slot="name">
        <a v-if="row.instro" @click="looks(row.instro)">{{ row.name }}</a>
        <span v-else>{{ row.name }}</span>
      </template>
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" @click="handleCheck(row)">查看课程
          <Icon type="ios-arrow-forward" />
        </Button>
      </template>

    </Table>
    <Modal title="介绍" v-model="visible">
      <div v-html="contents" style="width: 100%" />
      <div slot="footer">
        <Button type="text" size="small" @click="visible = false">取消</Button>
      </div>
    </Modal>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  import expandsRow from "./model.vue";
  export default {
    components: { expandsRow },
    props: {
      reSearch: {
        type: Object,
        default: {
          subject_id: ''
        }
      }
    },
    data() {
      return {
        page: {
          totlal: 10,
          currentPage: 1,
          pageSize: 10
        },
        contents: '',
        visible: false,
        data: [],
        tableColumns: [
          { title: "序号", slot: "index", width: 80, align: "center", },
          { title: "课程名称", slot: "name", align: "center", minWidth: 180, },
          { title: "章节数量", key: "count", align: "center", minWidth: 140, },
          { title: "级别", key: "grade_name", align: "center", minWidth: 140, },
          { title: "科目", key: "subject_name", align: "center", minWidth: 140, },
          {
            title: "去学习",
            type: "expand", align: "center",
            minWidth: 140,
            render: (h, params) => {
              var list = params.row.secions
              return h(expandsRow, {
                props: { rows: list }
              })
            },
          },
          { title: "操作", slot: "action", align: "center", width: 150, },
        ],
        indexUrl: "/app/curse/index",
        deleteUrl: "/app/my_course/delete",
      };
    },
    mixins: [indexPage],
    mounted() { },
    methods: {
      search() {
        this.searchData = this.reSearch;
      },
      looks(con) {
        this.visible = true
        this.contents = con
      },
      getProfile() {
        this.$router.push("/examinationBank/study");
      },

      handleCheck(row) {
        let index = 0
        let arr = [];
        this.tableData.data.forEach((item, i) => { //每次只能展开一个，其他自动收起
          arr.push(item);
          if (item.id == row.id) {
            index = i
          } else
            this.tableData.data[i]._expanded = false
        })
        this.tableData.data[index]._expanded = !this.tableData.data[index]._expanded;
        this.tableData.data = arr; //重置了整个表格的data这个展开才生效
      },



    },
  };
</script>
<style scoped lang="less">
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
  .wrapper {
    .list {
      width: 100%;
      height: 120px;
      display: flex;
      margin-top: 10px;
      border-bottom: 1px solid rgb(226, 226, 226);
      .item-content {
        width: 600px;
        text-align: center;
        .item:nth-child(1) {
          width: 100%;
          height: 60px;
          line-height: 60px;
          display: flex;
          div {
            width: 33%;
          }
        }
        .item:nth-child(2) {
          width: 100%;
          height: 60px;
          line-height: 60px;
          display: flex;
          justify-content: space-between;
          div:nth-child(1) {
            margin-left: 120px;
          }
          div:nth-child(2) {
            margin-right: 120px;
          }
          div {
            width: 100px;
            height: 30px;
            line-height: 30px;
            background: coral;
            font-size: 12px;
            color: #fff;
            cursor: pointer;
            border-radius: 4px;
          }
        }
      }
      .item-img {
        width: 300px;
        text-align: center;
        img {
          width: 140px;
          height: 100px;
        }
      }
    }
    .page {
      width: 100%;
      text-align: right;
    }
  }
</style>
